// Body of the Oscar account-registration view: the UtilityPage layout
// (customer-service side nav + content title) wrapping the ConvertLazyUserForm,
// whose fields render as a native React field tree. The submit label is
// hardcoded English (intentionally not translated).
import { Immutable } from "immer";
import React from "react";
import { duplicateEmailAfterField } from "tsi-common-react/src/forms/DuplicateEmailError/index";
import {
    FORM_CLASS_NAME,
    FORM_FIELD_SUBMIT_CLASS_NAME,
} from "tsi-common-react/src/forms/classNames";
import { jt } from "ttag";

import { templates } from "@reactivated";

import { CSRFToken } from "@reactivated/forms";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { FormFields } from "../FormFields";
import { SideNav } from "../SideNav";

type IProps = Immutable<templates.RegistrationDocumentTemplate>;

export const RegistrationBody = (props: IProps): React.JSX.Element => {
    const {
        has_nav,
        side_nav,
        content_title,
        phone_display,
        phone_href,
        action_url,
    } = props;
    // ttag's `jt` forbids a conditional/logical expression directly inside the
    // `${...}` interpolation, so compute the optional phone link first.
    const phoneLink = phone_display ? (
        <a key="phone" href={phone_href}>
            {phone_display}
        </a>
    ) : null;
    return (
        <div className="l-capped-width u-margin-bottom--xl u-full-width-title">
            {has_nav && (
                <div className="l-side-nav">
                    <SideNav items={side_nav} />
                </div>
            )}

            <div className="l-side-nav-content">
                <div className="content-title">
                    <h1 className="content-title__headline">{content_title}</h1>
                    <span className="content-title__info">
                        {jt`Talk to Sleep Expert ${phoneLink}`}
                    </span>
                </div>

                <div className="content__copy--full-width">
                    <div className="login-standalone">
                        <form
                            className={concatClassNames([
                                FORM_CLASS_NAME,
                                "js-kuid-form",
                            ])}
                            method="post"
                            action={action_url}
                        >
                            <CSRFToken />
                            <FormFields
                                fields={props.fields}
                                field_labels={props.field_labels}
                                field_errors={props.field_errors}
                                non_field_errors={props.non_field_errors}
                                afterField={duplicateEmailAfterField(props)}
                            />
                            <div className={FORM_FIELD_SUBMIT_CLASS_NAME}>
                                <input
                                    type="submit"
                                    className="button button--full-width"
                                    value="CREATE ACCOUNT"
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};
